<template>
  <div>
    <div style="display: flex; align-items: center">
      <v-btn class="mr-3"
             large
             icon
             text
             color="primary"
             @click="copyText(smoochRoute)">
        <v-icon color="kbGray">
          file_copy
        </v-icon>
      </v-btn>

      <div style="flex: auto">
        <div class="text-h6 font-weight-bold">
          URL
        </div>

        <p class="collapse-text">
          {{smoochRoute}}
        </p>
      </div>
    </div>

    <v-card-text cols="12">
      <v-form ref="smoochForm"
              lazy-validation
              :value="valid">
        <v-row>
          <v-col cols="12">
            <CountryPicker color="kbGreen"
                           v-model="country">
            </CountryPicker>
          </v-col>

          <v-col cols="12">
            <v-text-field color="kbGreen"
                          @keypress="checkKeyOnlyNumbers($event)"
                          label="Celular"
                          maxlength="12"
                          :rules="[rules.required]"
                          v-model="number">
              <template v-slot:prepend-inner>
                <span style="margin-top: 3px">
                  +{{country.number}}
                </span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Whatsapp App Id"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="smoochAppId">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Whatsapp Key Id"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="smoochKeyId">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Whatsapp Key Secret"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="smoochKeySecret">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Whatsapp Integration Id"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="smoochIntegrationId">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Namespace"
                          color="kbDarkBlue"
                          :rules="[rules.required]"
                          v-model="namespace">
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-switch color="kbLightBlue"
                      label="enable"
                      v-model="enable">
            </v-switch>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn color="kbLightBlue"
             dark
             @click="updateTemplates"
             :loading="loading" v-if="!this.new">
        Actualizar Templates
      </v-btn>

      <v-spacer/>

      <v-btn color="kbLightBlue"
             dark
             @click="submit"
             :loading="loading">
        {{this.new === true ?  $t('general.create') : $t('general.update')}}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import countries from '@/libs/countries'
import CountryPicker from '@/components/ui/CountryPicker.vue'
import { mapState } from 'vuex'
import notifications from '@/libs/notifications.js'
import rules from '@/libs/rules'
import conversationsService from '@/services/conversationsService.js'

export default {
  components: {
    CountryPicker
  },
  computed: {
    ...mapState({
      channelsInfo: state => state.conversations.channelsInfo
    }),
    smoochRoute () {
      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid
      const subdomain = `conversations${process.env.VUE_APP_NODE_ENV === 'development' ? 'test' : ''}`
      return `https://${subdomain}.keybe.bio/smooch/company/${companyId}/app/${appId}`
    }
  },
  async created () {
    const channelsInfo = await this.$store.dispatch('getChannelsInfo')
    this.$store.commit('SET_CHANNELS_INFO', channelsInfo)
    if (channelsInfo.smooch) this.setLocalInfo()
  },
  data () {
    return {
      countries: countries,
      country: {},
      enable: false,
      new: true,
      loading: false,
      namespace: '',
      number: '',
      phone: '',
      rules,
      smoochAppId: '',
      smoochIntegrationId: '',
      smoochKeyId: '',
      smoochKeySecret: '',
      valid: true
    }
  },
  methods: {
    submit () {
      if (!this.$refs.smoochForm.validate()) return

      this.loading = true

      this.new === true ? this.createSmoochInfo() : this.updateSmoochInfo()
    },
    changeCountry (value) {
      this.$emit('input', value)
    },
    checkKeyOnlyNumbers (event) {
      if (event.keyCode < 48 || event.keyCode > 58) {
        event.preventDefault()
      }
    },
    copyText (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success('Ruta copiada correctamente')
      }).catch(() => {
        notifications.error('Error al copiar la ruta')
      })
    },
    async createSmoochInfo () {
      try {
        const data = {
          phone: `+${this.country.number}${this.number}`,
          smoochAppId: this.smoochAppId,
          smoochKeyId: this.smoochKeyId,
          smoochKeySecret: this.smoochKeySecret,
          smoochIntegrationId: this.smoochIntegrationId,
          enable: this.enable,
          country: this.country.code,
          number: this.number,
          namespace: this.namespace
        }

        await this.$store.dispatch('createSmoochInfo', data)
        notifications.success('información registrada correctamente')
        this.loading = false
        this.new = false
      } catch (e) {
        this.loading = false
        notifications.error(e.message)
      }
    },
    setLocalInfo () {
      if (!this.channelsInfo || !this.channelsInfo.smooch) return

      this.number = this.channelsInfo.smooch.number
      this.smoochAppId = this.channelsInfo.smooch.smooshAppId
      this.smoochKeyId = this.channelsInfo.smooch.smooshKeyId
      this.smoochKeySecret = this.channelsInfo.smooch.smooshKeySecret
      this.smoochIntegrationId = this.channelsInfo.smooch.smooshIntegrationId
      this.new = false
      this.enable = this.channelsInfo.smooch.enable
      this.country = countries.find(element => {
        return element.code === this.channelsInfo.smooch.country
      })
      if (this.channelsInfo.smooch.options.namespace) {
        this.namespace = this.channelsInfo.smooch.options.namespace
      }
    },
    async updateSmoochInfo () {
      try {
        const data = {
          phone: `+${this.country.number}${this.number}`,
          smoochAppId: this.smoochAppId,
          smoochKeyId: this.smoochKeyId,
          smoochKeySecret: this.smoochKeySecret,
          smoochIntegrationId: this.smoochIntegrationId,
          enable: this.enable,
          country: this.country.code,
          number: this.number,
          namespace: this.namespace
        }

        await this.$store.dispatch('updateSmoochInfo', data)
        notifications.success('información actualizada correctamente ')
        this.loading = false
      } catch (e) {
        this.loading = false
        notifications.error(e.message)
      }
    },
    async updateTemplates () {
      try {
        const token = this.$store.getters.token
        const companyId = this.$store.getters.companyUuid
        const appId = this.$store.getters.appUuid
        await conversationsService.updateTemplates(token, companyId, appId)
        notifications.success('Templates actualizados correctamente ')
      } catch (e) {
        notifications.error('Error al actualizar Templates')
      }
    }
  }
}
</script>
